<template>
    <div class="logistics-status" v-loading="loading">
        <el-tabs v-model="activeName" @tab-click="handleClick" :class="{'onlyOne': listData.length === 1}">
            <el-tab-pane :label="item.sendNumber" :name="item.seqNum" v-for="(item, index) in listData" :key="index">
                <div class="status-code">
                    <img :src="require(`../assets/img/status-${item.isFinish ? 'finish' : 'proce'}.png`)"/>
                </div>
                <ul>
                    <li v-for="(itm, idx) in item.axisVoList" :key="idx" :class="{'is-active': (idx==0 && itm.statusGroupName !='TOP') || (idx == 1 && item.axisVoList[0].statusGroupName == 'TOP'), 'receipt': itm.statusGroupName == 'TOP'}">
                        <p class="tit">{{itm.nodeName}}</p>
                        <p v-if="itm.number"><span v-if="itm.operateTimeStr">{{itm.operateTimeStr || ''}} &nbsp;&nbsp;&nbsp;</span> {{itm.remark.split(itm.number)[0]}} <span class="number" @click="showDialog(itm)">{{itm.number}}</span> <span @click="copyWareInfo(itm.number.trim())"> <ab-svg name="copy1" ></ab-svg></span>{{itm.remark.split(itm.number)[1]}}</p>
                        <p v-else><span v-if="itm.operateTimeStr">{{itm.operateTimeStr || ''}}&nbsp;&nbsp;&nbsp;</span> {{itm.index ? itm.remark.substring(0, itm.index) : itm.remark}}</p>
                        <p v-if="itm.index">{{itm.remark.substring(itm.index, itm.remark.length)}}</p>
                        <div class="circle1" v-if="idx == 0 && itm.statusGroupName == 'TOP'">收</div>
                        <div class="circle" v-else></div>
                    </li>
                </ul>
            </el-tab-pane>
        </el-tabs>
        <el-dialog
        class="no-padding special-dialog"
        @close="deliverTransportNo=''"
        append-to-body
        title="运单跟踪"
        v-model="dialogVisible"
        top="0vh"
        width="500px">
        <ab-logisticsInfo :deliverTransportNo="deliverTransportNo" :isInter="isInter" maxHeight="95vh">
        </ab-logisticsInfo>
        </el-dialog>
        <textarea style="width: 0; height: 0" id="inputCopy">这是幕后黑手</textarea>
    </div>
</template>

<script>
export default {
    name: 'ab-logistics-status',
    data () {
        return { 
            dialogVisible: false,
            deliverTransportNo: '',
            isInter: false,
            activeName: 0,
            listData: [],
            loading: false,
            progress: 0
        }
    },
    methods: {
        getNumber(txt) {
            let num = ''
            if(txt && txt.indexOf('单号：') != -1 || txt.indexOf('单号:') != -1) {
                let a = txt.indexOf('单号：') != -1 ? '单号：' : '单号:'
                let b = txt.split(a)[1].indexOf('，') != -1 || txt.split(a)[1].indexOf(',') != -1 ? txt.split(a)[1].indexOf('，') != -1 ? '，' : ',' : ''
                if(a && b) {
                return txt.split(a)[1].split(b)[0]
                }
            }
            return num
        },
        splitRemark(txt) {
            let num = 0
            if(txt && txt.indexOf('感谢') != -1) {
                num = txt.indexOf('感谢')
            }
            return num
        },
        getStatusTimeAxis(entrustId, bizType) {
            this.listData = []
            this.loading = true
            this.$post('/oms/client/entrustStatus/getStatusTimeAxis', { entrustId: entrustId, bizType: bizType, isShowOut: true }).then(({ data }) => {
                if (data.code === 'C0000') {
                this.listData = data.result
                // this.listData[1][1].remark = '但是灌水灌水单号：432668684435158，高浮雕高浮雕'
                this.listData.forEach(element=>{
                    element.axisVoList.forEach(ele => {
                        ele.number = this.getNumber(ele.remark)
                        ele.index = this.splitRemark(ele.remark)
                    })
                })
                this.$nextTick(() => {
                    this.activeName = this.listData[0].seqNum
                })
                
                } else {
                    this.$message({
                        type: 'error',
                        message: data.message,
                        grouping: true,
                        offset: 380
                    })
                }
            }).finally(() => {
                this.loading = false
            })
        },
        copyWareInfo(text) {
            var input = document.getElementById("inputCopy");  // 找到虚拟的输入框
            input.value = text; // 修改文本框的内容
            input.select(); // 选中文本
            document.execCommand("copy"); // 执行浏览器复制命令
            this.$message({
                type: 'success',
                message: '复制成功!',
                grouping: true,
                offset: 380
            })
        },
        handleClick() {

        },
        showDialog(row) {
            this.dialogVisible = true
            this.$nextTick(() => {
                this.isInter = row.statusGroupName == 'ordered'
                this.deliverTransportNo = row.number ? row.number.trim() : ''
            })
        }
    }
}
</script>

<style lang="scss">
    .logistics-status{
        margin-top: 20px;
            ::-webkit-scrollbar{
                width: 2px;
            }
        .el-tabs__content{
            height: calc(100vh - 135px);
            overflow-y: auto;
        }
        .status-code{
            height: 50px;
            width: 100%;
            position: relative;
            img{
                position: absolute;
                right: 0px;
            }
        }
        .el-tabs__nav{
            .el-tabs__item{
                padding: 0 10px;
                background-color: #fff;
                border: none;
                font-size: 14px;
            }
            .el-tabs__item.is-active{
                color: #167fff;
                font-size: 16px;
                padding: 0 10px;
                // &::before{
                //     content: '';
                //     position: absolute;
                //     width: 100%;
                //     height: 2px;
                //     left: 0px;
                //     background-color: #167fff;
                //     bottom: 0px;
                // }
            }
        }
        .el-tabs__nav-wrap{
            border-bottom: 1px solid #f7f7f7;
            &::after{
                display: none;
            }
        }
        .title{
            height: 50px;
            line-height: 50px;
            text-align: center;
            font-size: 20px;
            color: #167fff;
        }
        ul{
            padding: 0 20px;
            li.receipt{
                .tit {
                    font-size: 16px;
                }
                padding-bottom: 20px;
                p{
                    // margin-top: 8px;
                    line-height: 20px;
                    font-size: 14px;
                    display: inline-block;
                }
                p:first-child{
                    font-size: 16px;
                    margin-right: 10px;
                }
                .circle1{
                    position: absolute;
                    width: 26px;
                    height: 26px;
                    border-radius: 50%;
                    left: -13px;
                    background-color: #157fff;
                    color: #fff;
                    font-size: 14px;
                    text-align: center;
                    line-height: 26px;
                    top: 0;
                }
            }
            li{
                position: relative;
                padding: 0px 0 25px 20px;
                border-left: 1px dashed #c9c9c9;
                p{
                    color: #848587;
                    font-size: 14px;
                    line-height: 14px;
                    margin-bottom: 10px;
                }
                .tit{
                    color: #2b3644;
                    font-size: 16px;
                }
                .circle{
                    top: 0;
                    position: absolute;
                    width: 14px;
                    height: 14px;
                    border-radius: 50%;
                    border: 2px solid #b4b4b4;
                    left: -7px;
                    background-color: #fff;
                }
                &:last-child{
                    border: none;
                }
                .number{
                    color: #167fff;
                    cursor: pointer;
                }
                    svg{
                        width: 12px;
                        top: 4px;
                        position: relative;
                        height: 16px;
                        color: #157fff;
                        cursor: pointer;
                    }
            }
            .is-active{
                p{
                    color: #157fff;
                }
                .circle{
                    border-color: #157fff;
                    &::before{
                        width: 6px;
                        height: 6px;
                        content: '';
                        position: absolute;
                        top: 2px;
                        left: 2px;
                        background-color: #157fff;
                        border-radius: 50%;
                    }
                }
            }
        }
    }
</style>
<style lang="scss">
    .popup-add-data .el-dialog__body{
        padding-top: 1px;
    }
    .no-padding .el-dialog__body{
        padding: 0;
    }
    .special-dialog{
        height: 100vh;
        margin-bottom: 0;
        overflow: hidden;
    }
    .onlyOne{
        .el-tabs__header{
            display: none;
        }
    }
        .el-tabs__header{
            margin-bottom: 0;
        }
</style>